import {RowContextAction} from '@/incoming-balance/types/RowContextAction.type'
import {CsvDataRow} from '@/incoming-balance/types/CsvDataRow.type'
import subAccountComposable from '@/incoming-balance/subaccount.composable'
import {fetchCustomers, fetchSuppliers} from '@/subaccount/subAccount.service'

const {useCustomerBalance, useSupplierBalance} = subAccountComposable()
const customerBalance = useCustomerBalance()
const supplierBalance = useSupplierBalance()


export const getSubAccountRowActions = (row: CsvDataRow, isCustomer: boolean): RowContextAction[] => {
    const actions: RowContextAction[] = []
    const isMissing = isCustomer ? customerBalance.isSubAccountMissing(row) : supplierBalance.isSubAccountMissing(row)
    const isMisnamed = isCustomer ? customerBalance.isSubAccountMisnamed(row) : supplierBalance.isSubAccountMisnamed(row)
    const isInactive = isCustomer ? customerBalance.subAccountNeedsActivation(row) : supplierBalance.subAccountNeedsActivation(row)

    if (isMissing) {
        actions.push({
            name: isCustomer ? 'Opprett kunde' : 'Opprett leverandør',
            icon: '<i class="i-ph-plus inline-block align-middle"/>',
            action: () => createSubAccount(row, isCustomer)
        })
    }

    if (isMisnamed) {
        actions.push({
            name: `Endre navn på ${isCustomer ? 'kunde' : 'leverandør'} i systemet`,
            icon: '<i class="i-ph-pencil inline-block align-middle"/>',
            action: () => correctMisnamed(row, isCustomer)
        })
    }

    if (isInactive) {
        actions.push({
            name: `Aktiver ${isCustomer ? 'kunde' : 'leverandør'}`,
            icon: '<i class="i-ph-check inline-block align-middle"/>',
            action: () => activate(row, isCustomer)
        })
    }

    return actions
}

const createSubAccount = async (row: CsvDataRow, isCustomer: boolean) => {
    if (isCustomer) {
        await customerBalance.createMissingSubAccount(row)
        await fetchCustomers()
    } else {
        await supplierBalance.createMissingSubAccount(row)
        await fetchSuppliers()
    }
}

const correctMisnamed = async (row: CsvDataRow, isCustomer: boolean) => {
    if (isCustomer) {
        await customerBalance.correctMisnamedSubAccount(row)
        await fetchCustomers()
    } else {
        await supplierBalance.correctMisnamedSubAccount(row)
        await fetchSuppliers()
    }
}

const activate = async (row: CsvDataRow, isCustomer: boolean) => {
    if (isCustomer) {
        await customerBalance.activateSubAccount(row)
        await fetchCustomers()
    } else {
        await supplierBalance.activateSubAccount(row)
        await fetchSuppliers()
    }
}

